import './App.css';
import React, { useState, useEffect, useRef  } from "react";
import Navbar from './components/Navbar';
import Footer from "./components/Footer";
import Index from './components/Home';
import { Routes, Route, useLocation } from 'react-router-dom';
import CareerSection from './components/CareerSection';
import HealthInsaurance from './components/Health-insurance';
import HouseInsurance from './components/House-insurance';
import CarInsurance from './components/Cheap-car-automobile-quotes';
import CompareLifeInsurance from './components/Compare-life-insurance';
import ContactUs from './components/Contact';
import TravelInsurance from './components/Travel-insurance';
import BussinessInsurance from './components/Bussiness-insurance';
import IframeDisplay from './components/IframeDisplay';

const App = () => {
  const location = useLocation();
  const [selectedPage, setSelectedPage] = useState('Home Page');

  useEffect(() => {
    // Determine the selected page based on the URL
    switch (location.pathname) {
      case '/health-insurance':
        setSelectedPage('Health Insurance Page'); // Health Insurance - ID 1
        break;
      case '/travel-insurance':
        setSelectedPage('Travel Insurance Page'); // Travel Insurance - ID 2
        break;
      case '/business-insurance':
        setSelectedPage('Business Insurance Page'); // Business Insurance - ID 3
        break;
      case '/cheap-car-automobile-quotes':
        setSelectedPage('Car Insurance Page'); // Car Insurance - ID 4
        break;
      case '/house-insurance':
        setSelectedPage('House Insurance Page'); // House Insurance - ID 5
        break;
      case '/compare-life-insurance':
        setSelectedPage('Life Insurance Page'); // Life Insurance - ID 6
        break;
      default:
        setSelectedPage('Home Page');
        break;
    }
  }, [location]);

  const careerSectionRef = useRef(null);

  // Function to scroll to the career section
  const scrollToCareer = () => {
    careerSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div>
      <Navbar scrollToCareer={scrollToCareer}/>
      <Routes>
        <Route path='/' element={<Index />} />
        <Route path='/health-insurance' element={<HealthInsaurance />} />
        <Route path='/travel-insurance' element={<TravelInsurance />} />
        <Route path='/business-insurance' element={<BussinessInsurance />} />
        <Route path='/cheap-car-automobile-quotes' element={<CarInsurance />} />
        <Route path='/house-insurance' element={<HouseInsurance />} />
        <Route path='/compare-life-insurance' element={<CompareLifeInsurance />} />
        <Route path='/contact' element={<ContactUs />} />
      </Routes>
      {/* Display iframe for the selected page */}
      <IframeDisplay page={selectedPage} />
      <CareerSection ref={careerSectionRef}/>
      <Footer />
    </div>
  );
};

export default App;
